import React, { ComponentProps } from "react";
import * as S from "./styles";

interface ITextAreaProps extends ComponentProps<"textarea"> {}
export const TextArea = React.forwardRef<HTMLTextAreaElement, ITextAreaProps>(
  (props: ITextAreaProps, ref) => {
    return <S.MyTextArea {...props} ref={ref} />;
  }
);
